import { render, staticRenderFns } from "./ServiceTypes.vue?vue&type=template&id=4beb7c30"
import script from "./ServiceTypes.vue?vue&type=script&lang=js"
export * from "./ServiceTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports